export default __webpack_public_path__ + "static/media/lending _Image.872d961d.png";